import { pageInfo, exportData} from './../api';
import { Message } from 'element-ui';
import { contractType, goodsCategory, plant, supplierList } from '../../../../api'
const qcSecondary = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateResp: null,
    exportObj: [],
    supplierObj: null,
    contractTypeObj: [],
    goodsCategoryObj: [],
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    SUPPLIER_LIST(state, data) {
      state.supplierObj = data;
    },
    CONTRACT_TYPE(state, data) {
      state.contractTypeObj = data;
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async supplierList({commit}, obj) {
      let resp = await supplierList(obj);
      commit('SUPPLIER_LIST', resp);
    },
    async contractType({commit}, obj) {
      let resp = await contractType(obj);
      commit('CONTRACT_TYPE', resp);

    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
  }
}
export default qcSecondary



// WEBPACK FOOTER //
// ./src/page/report/qcSecondary/store/qcSecondary.store.js